module.exports = __webpack_public_path__ + "img/公司-北京.c1ab0364.png";